import { Modal } from 'antd'

import styles from './B2becEnquiryModal.module.scss'

const B2becEnquiryModal = ({ children }) => {
  return (
    <Modal
      open
      className={styles.enquiryModule}
      closable={false}
      footer={null}
      width={570}
    >
      {children}
    </Modal>
  )
}

const B2becEnquiryModalFooter = ({ children }) => {
  return <div className="enquiry-modal__footer">{children}</div>
}

B2becEnquiryModal.Footer = B2becEnquiryModalFooter

export default B2becEnquiryModal
